import { post } from "../../xhr/api";

export const store_payment=(data)=> {
    return post('api/payment',{},data,true);
}